// src/redux/constants/promptConstants.js
export const PROMPT_REQUEST = 'PROMPT_REQUEST'
export const PROMPT_SUCCESS = 'PROMPT_SUCCESS'
export const PROMPT_FAIL = 'PROMPT_FAIL'
